






import { Component, Mixins, Prop } from "vue-property-decorator";

@Component
export default class MenuPane extends Mixins() {
  @Prop({ default: false })
  isHorizontal: boolean;

  get className(): string {
    return this.isHorizontal ? "horizontal-menu-pane-root" : "";
  }
}
